// extracted by mini-css-extract-plugin
module.exports = {"signInContainer":"SignUp_signInContainer__18U1s","module":"SignUp_module__3BkJL"};